export default "__VITE_ASSET__DzGkGPPl__"